// index.js
import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import App from './App'
import reportWebVitals from './reportWebVitals'
import { GC_TIME } from './constants/queryConstants'
import { DataProvider } from './context/DataContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: GC_TIME
    }
  }
})

const root = createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient} >
      <DataProvider>
        <App />
      </DataProvider>
    </QueryClientProvider>
  </React.StrictMode>
)

reportWebVitals()
